import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";

export class FormValidations {
  static rangeDDD = [
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "21",
    "22",
    "24",
    "27",
    "28",
    "31",
    "32",
    "33",
    "34",
    "35",
    "37",
    "38",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "51",
    "53",
    "54",
    "55",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "71",
    "73",
    "74",
    "75",
    "77",
    "79",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
  ];
  // tslint:disable-next-line:max-line-length
  // date
  static regexDateOfBirth = RegExp(
    /((0[1-9]|[12][0-9]|3[01])\/(0[13578]|1[02])\/[12][0-9]{3})|((0[1-9]|[12][0-9]|30)\/(0[469]|11)\/[12][0-9]{3})|((0[1-9]|1[0-9]|2[0-8])\/02\/[12][0-9]([02468][1235679]|[13579][01345789]))|((0[1-9]|[12][0-9])\/02\/[12][0-9]([02468][048]|[13579][26]))/gi
  );
  // documentName
  static nameLastname = RegExp(/[A-za-z].* [A-za-z].*/);
  static maxNineNames = RegExp(
    /[A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].* [A-za-z].*/
  );
  static spaceStartOrEnd = RegExp(/^[^\s].+[^\s]$/);
  static multipleSpaces = RegExp(/\s\s+/g);
  static repeated = RegExp(/(\w)\1{2}/);
  static repeatedLetter = RegExp(/([a-zA-Z])\1{2}/, "");
  // rg
  static minlengthRg = RegExp(/[0-9a-zA-Z]{6}/);
  static numberCharacterRg = RegExp(/^[A-zÀ-ú '´]+$/);
  static numberRepeatedRg = RegExp(/(\d)\1{5}/);
  static characterRepeatedRg = RegExp(/([^\d])\1{3}/);
  // rne
  static minlengthRne = RegExp(/[0-9a-zA-Z]{8}/);
  static numberCharacterRne = RegExp(/^[A-zÀ-ú '´]+$/);
  static numberRepeatedRne = RegExp(/(\d)\1{5}/);
  static characterRepeatedRne = RegExp(/([^\d])\1{3}/);
  // cnh
  static minlengthCnh = RegExp(/[0-9]{11}/);
  static numberRepeatedCnh = RegExp(/(\d)\1{5}/);
  // cep
  static repeatedAdrressNumber = RegExp(/([^\d])\1{2}/);
  // cidade nasc
  static numberCharacterCity = RegExp(/^[0-9]+$/);
  static spaceString = RegExp(/\s/g);
  // cnpj
  static minlengthCnpj = RegExp(/[0-9]{14}/);

  // nif
  static numberRepeatedNif = RegExp(/(\d)(\1){4}/);

  // email
  static email = RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9][a-zA-Z0-9\\-]+\.)+[a-zA-Z]{2,}))$/
  );

  // phone
  static numberRepeatedPhone = RegExp(/(\d)\1{7}/);

  static validSpace = RegExp(/\S/);

  // onlyCharacters
  static onlyCharacters = RegExp(/^[a-zA-Z]+$/);
  // onlyNumber
  static onlyNumbers = RegExp(/^\d+$/);
  //Alphanumeric
  static alphanumeric = RegExp(/^[a-z0-9]+$/i);
  // characters not allowed
  static specialCharacters = RegExp(/^[a-zA-Z0-9]+$/);
  

  static checkShortNameUser(control: FormControl): ValidationErrors | null {
    const minLength = 2;
    const maxLength = 50;
    const val = control.value.replace(/[^a-zA-Z\s]/g, "");
    let validator = null;

    if (val.length !== 0) {
      if (val.length < minLength) {
        validator = { checkShortNameMin: true };
      }

      if (val.length > maxLength) {
        validator = { checkShortNameMax: true };
      }
    }

    return validator;
  }

  static checkMotherName(control: FormControl): ValidationErrors | null {
    const val = control.value.replace(/[^a-zA-Z\s]/g, "");
    const arrName = val.split(" ");
    const minLength = 2;
    const maxLength = 250;
    if (val.length > 0) {
      if (val.length < minLength || arrName[0].length < minLength) {
        return { checkShortNameMin: true };
      }
      if (val.length > maxLength) {
        return { checkShortNameMax: true };
      }
    }
    return null;
  }

  static checkShortName(control: FormControl): ValidationErrors | null {
    const minLength = 2;
    const maxLength = 40;
    const val = control.value.replace(/[^a-zA-Z\s]/g, "");
    const arrName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (val.length < minLength || arrName[0].length < minLength) {
        validator = { checkShortNameMin: true };
      }

      if (val.length > maxLength) {
        validator = { checkShortNameMax: true };
      }
    }

    return validator;
  }

  static checkShortNameComplete(control: FormControl): ValidationErrors | null {
    const minLength = 2;
    const maxLength = 60;
    const val = control.value.replace(/[^a-zA-Z\s]/g, "");
    const arrName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (val.length < minLength || arrName[0].length < minLength) {
        validator = { checkShortNameMin: true };
      }

      if (val.length > maxLength) {
        validator = { checkShortNameMax: true };
      }
    }

    return validator;
  }

  static checkShortSpouseName(control: FormControl): ValidationErrors | null {
    const minLength = 3;
    const maxLength = 50;
    const val = control.value.replace(/[^a-zA-Z\s]/g, "");
    const arrName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (
        val.length < minLength ||
        arrName[0].length < minLength ||
        arrName[arrName.length - 1].length < minLength
      ) {
        validator = { checkShortNameMin: true };
      }

      if (val.length > maxLength) {
        validator = { checkShortNameMax: true };
      }
    }

    return validator;
  }

  static checkShortNameCity(control: FormControl): ValidationErrors | null {
    const minLength = 3;
    const maxLength = 60;
    const val = control.value;
    const arrName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (arrName.length > 1) {
        if (arrName[0].length < minLength) {
          validator = { checkShortNameMin: true };
        }
      }

      if (val.length > maxLength) {
        validator = { checkShortNameMax: true };
      }
    }

    return validator;
  }

  static checkShortPhone(control: FormControl): ValidationErrors | null {
    const minLength = 10;
    const val = control.value.replace(/[^0-9]+/gm, "").replace(" ", "");

    const ddd = val.substring(0, 2);
    const firstNumberPhone = val.substring(2, 3);
    let validator = null;

    if (val.length !== 0) {
      if (
        val.length < minLength ||
        (val.length <= minLength && firstNumberPhone === "9") ||
        firstNumberPhone === "0" ||
        firstNumberPhone === "1" ||
        FormValidations.rangeDDD.indexOf(ddd) === -1 ||
        FormValidations.numberRepeatedPhone.test(val)
      ) {
        validator = { checkShortMin: true };
      }
    }

    return validator;
  }

  static validationsName(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;
    const lastName = val.split(" ");

    if (val.length !== 0) {
      if (!FormValidations.nameLastname.test(val)) {
        validator = { nameLastname: true };
      }
      if (FormValidations.maxNineNames.test(val)) {
        validator = { maxNinename: true };
      }
      if (lastName.length > 0 && lastName[lastName.length - 1] === " ") {
        validator = { nameSpace: true };
      }
      if (FormValidations.repeated.test(val)) {
        validator = { repeated: true };
      }

      return validator;
    }
  }

  static validationsNameV2(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;
    const lastName = val.split(" ");

    if (val.length !== 0) {
      if (!FormValidations.nameLastname.test(val)) {
        validator = { nameLastname: true };
      }
      if (FormValidations.repeated.test(val)) {
        validator = { repeated: true };
      }
      return validator;
    }
  }

  static validationsNumberRg(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;

    if (val.length !== 0) {
      if (!FormValidations.minlengthRg.test(val)) {
        validator = { minlengthRg: true };
      }
      if (FormValidations.numberCharacterRg.test(val)) {
        validator = { numberCharacterRg: true };
      }
      if (FormValidations.numberRepeatedRg.test(val)) {
        validator = { numberRepeatedRg: true };
      }
      if (FormValidations.characterRepeatedRg.test(val)) {
        validator = { characterRepeatedRg: true };
      }
      return validator;
    }
  }

  static validationsNumberRne(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;

    if (val.length !== 0) {
      if (!FormValidations.minlengthRne.test(val)) {
        validator = { minlengthRne: true };
      }
      if (FormValidations.numberCharacterRne.test(val)) {
        validator = { numberCharacterRne: true };
      }
      if (FormValidations.numberRepeatedRne.test(val)) {
        validator = { numberRepeatedRne: true };
      }
      if (FormValidations.characterRepeatedRne.test(val)) {
        validator = { characterRepeatedRne: true };
      }
      return validator;
    }
  }

  static validationsNumberCnh(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;

    if (val.length !== 0) {
      if (!FormValidations.minlengthCnh.test(val)) {
        validator = { minlengthCnh: true };
      }
      if (FormValidations.numberRepeatedCnh.test(val)) {
        validator = { numberRepeatedCnh: true };
      }

      return validator;
    }
  }

  static validationsNumberAddress(
    control: FormControl
  ): ValidationErrors | null {
    if (control.value != "") {
      const valString = control.value.toString();
      const val = valString.replace(/[^a-z\d\s/]+/gi, "");
      const lastName = val.split(" ");
      let validator = null;

      if (val.length !== 0) {
        if (FormValidations.repeatedAdrressNumber.test(val)) {
          validator = { repeated: true };
        }

        if (lastName.length >= 1 && lastName[lastName.length - 1] === " ") {
          validator = { nameSpace: true };
        }

        if (val.length > 5) {
          validator = { minlengthNumerAddress: true };
        }

        return validator;
      }
    }
  }

  static validationsNameAddress(control: FormControl): ValidationErrors | null {
    const val = control.value.replace(/[^a-z\d\s]+/gi, "");
    const lastName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (FormValidations.repeated.test(val)) {
        validator = { repeated: true };
      }

      if (lastName.length >= 1 && lastName[lastName.length - 1] === "") {
        validator = { nameSpace: true };
      }

      return validator;
    }
  }

  static validationWithRepetition(control: FormControl): ValidationErrors | null {
    const val = control.value.replace(/[^a-z\d\s]+/gi, "");
    const lastName = val.split(" ");
    let validator = null;
    
    if (val.length !== 0) {
      if (lastName.length >= 1 && lastName[lastName.length - 1] === "") {
        validator = { nameSpace: true };
      }
      return validator;
    }
    return null;
  }

  static validationsNumberAddressNoRequired(
    control: FormControl
  ): ValidationErrors | null {
    const val = control.value.replace(/[^a-zA-Z0-9\s]/g, "");
    const lastName = val.split(" ");
    let validator = null;

    if (FormValidations.repeated.test(val)) {
      validator = { repeated: true };
    }

    if (lastName.length > 1 && lastName[lastName.length - 1] === "") {
      validator = { nameSpace: true };
    }

    return validator;
  }

  static validationsDate(control: FormControl): ValidationErrors | null {
    const val = control.value;
    const typedDate = val.split("/");
    const typedYear = parseInt(typedDate[2], 10);
    const currentDate = new Date();
    let isDateGreater = false;

    if (val.length !== 0) {
      if (val !== "" && val?.length === 10) {
        const dateTyped = new Date(
          typedDate[2],
          typedDate[1] - 1,
          typedDate[0]
        );
        isDateGreater = dateTyped.getTime() > currentDate.getTime();
      }

      if (
        val !== "" &&
        (!val.match(FormValidations.regexDateOfBirth) ||
          typedYear < 1900 ||
          isDateGreater)
      ) {
        return { dateInvalid: true };
      }

      return null;
    }
  }

  static validationsNameCity(control: FormControl): ValidationErrors | null {
    const val = control.value.replace(/[^a-z\d\s]+/gi, "");
    const lastName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (FormValidations.repeated.test(val)) {
        validator = { repeated: true };
      }

      if (lastName.length > 1 && lastName[lastName.length - 1] === "") {
        validator = { nameSpace: true };
      }

      if (FormValidations.numberCharacterCity.test(val)) {
        validator = { numberCharacter: true };
      }
      return validator;
    }
  }

  static validationsNumberCnpj(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;

    if (val.length !== 0) {
      if (!FormValidations.minlengthCnpj.test(val)) {
        validator = { minlength: true };
      }
      return validator;
    }
  }

  static validationsNameCnpj(control: FormControl): ValidationErrors | null {
    const val = control.value;
    const lastName = val.split(" ");
    let validator = null;

    if (val.length !== 0) {
      if (val.length < 3) {
        validator = { minLength: true };
      }

      if (val.length > 22) {
        validator = { maxLength: true };
      }

      if (lastName.length > 1 && lastName[lastName.length - 1] === "") {
        validator = { nameSpace: true };
      }
      return validator;
    }
  }

  static validationsNifFormat(type: string, control: AbstractControl, characters?: string): ValidationErrors | null {
    const val = control.value;
    const space = /\s/;

    const allDisallowedChars = characters + '“”‘’';
    const containsDisallowedChars = [... allDisallowedChars].some(char => val.includes(char))

    switch (type) {
      case "SOMENTE_LETRAS":
        return this.onlyCharacters.test(val) ? null : { onlyCharacters: true };
      case "SOMENTE_NUMEROS":
        return this.onlyNumbers.test(val) ? null : { onlyNumbers: true };
      case "ALFANUMERICO":
        return this.alphanumeric.test(val) ? null : { alphanumeric: true };
      case "COM_CARACTERES_ESPECIAIS":
        return space.test(val) || containsDisallowedChars ? { charactersNotAllowed: true } : null;
      default:
        return null;
    }
  }

  static validationsNumberTin(control: FormControl): ValidationErrors | null {
    const val = control.value
      .replace(/[^a-z0-9/+-/]/gi, "")
      .replace("++", "+")
      .replace("--", "-")
      .replace("//", "/")
      .replace("+-", "+")
      .replace("+/", "+")
      .replace("-+", "-")
      .replace("-/", "-")
      .replace("/+", "/")
      .replace("/-", "/")
      .replace(".", "")
      .replace(",", "")
      .replace(/  +/g, "");
    let validator = null;

    if (val.length !== 0) {
      if (val.length <= 1) {
        validator = { minlengthTin: true };
      }
      if (FormValidations.numberRepeatedNif.test(val)) {
        validator = { numberRepeatedNif: true };
      }
      return validator;
    }
  }

  static validationsNameConjuge(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;

    if (val.length !== 0) {
      if (!FormValidations.nameLastname.test(val)) {
        validator = { nameLastname: true };
      }
      if (!FormValidations.spaceStartOrEnd.test(val)) {
        validator = { nameSpace: true };
      }
      if (FormValidations.repeated.test(val)) {
        validator = { repeated: true };
      }
      return validator;
    }
  }

  static validationsNameDoc(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;
    const lastName = val.split(" ");

    if (val.length !== 0) {
      if (lastName.length > 1 && lastName[lastName.length - 1] === "") {
        validator = { nameSpace: true };
      }
      if (FormValidations.repeated.test(val.toLowerCase())) {
        validator = { repeated: true };
      }
      return validator;
    }
  }

  static validationEmail(control: FormControl): ValidationErrors | null {
    const val = control.value;
    let validator = null;
    const lastVal = val.split("@");
    const caracterLength = 64;

    if (val.length !== 0) {
      if (lastVal[0].length > caracterLength) {
        validator = { caracterLength: true };
      }

      if (!FormValidations.email.test(val)) {
        validator = { email: true };
      }
      return validator;
    }
  }
}
